import React from "react";

const TeamCard = ({ team, order, ...rest }) => {
  const { name, faculty, image, role } = team;

  const isDirector = role?.includes("Director of");

  return (
    <div
      className={`flex flex-col items-center max-w-[152px] z-10
        ${
          order === "1"
            ? "md:max-w-[296px]"
            : order === "2"
            ? "md:max-w-[216px]"
            : "md:max-w-[208px]"
        }`}
    >
      {order === "3" && (
        <span className="font-medium text-wce-peach mb-4 text-center">
          {isDirector ? (
            <>
              Director of <br />
              {role?.substring(12)}
            </>
          ) : (
            role
          )}
        </span>
      )}
      <div
        className={`flex flex-col bg-wce-navy p-4 hover:bg-wce-navy-light h-full
            rounded-3xl items-center cursor-pointer duration-200 min-h-[164px] w-[152px]
            ${
              order === "1"
                ? "md:w-[296px] md:max-w-[296px] md:min-h-[232px]"
                : order === "2"
                ? "md:w-[216px] md:max-w-[216px] md:min-h-[200px]"
                : "md:w-[208px] md:max-w-[208px] md:min-h-[168px]"
            }`}
        {...rest}
      >
        <div className="mb-4">
          <img
            className={`w-[64px] ${
              order === "1"
                ? "md:w-[120px]"
                : order === "2"
                ? "md:w-[96px]"
                : "md:w-[72px]"
            }`}
            style={{
              objectFit: "cover",
              objectPosition: "center",
              borderRadius: "100%",
              height: "auto",
            }}
            src={image}
            alt={"team"}
          />
        </div>
        <div
          className={`font-medium text-white text-center text-sm
          ${
            order === "1"
              ? "mb-2 md:text-xl"
              : order === "2"
              ? "mb-2 md:text-base"
              : "mb-1"
          }`}
        >
          {name}
        </div>
        <div
          className={`text-white text-sm ${
            order === "1"
              ? "mb-2 md:text-lg"
              : order === "2"
              ? "mb-2 md:text-base"
              : "mb-1"
          }`}
        >
          {faculty}
        </div>
      </div>
    </div>
  );
};

export default TeamCard;
